<!-- 评分弹窗 -->
<template>
  <div class="popup-list">
    <!-- 未设置考核 -->
    <gat-popup
      :class="['popup-score', popupActive === 'score' ? 'on' : 'off']"
      :title="scoreTitle"
      :primary-button="'确定'"
      @cancel="cancelPopup"
      @confirm="UpdateScore($event)"
    >
      <template v-slot:content>
        <el-form ref="submitProject" :model="Project" label-width="100px">
          <el-form-item label="学生自评情况" class="strong-label">
            <label class="require-icon">
              1.是否已掌握项目实训点及技能点？
            </label>
            <el-input
              type="textarea"
              v-model.trim="Project.Points"
              :rows="3"
              maxlength="200"
              show-word-limit
              :disabled="submitShow"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <label class="require-icon">2.实训项目的预设目标有没有实现？效果如何？</label>
            <el-input
              type="textarea"
              v-model.trim="Project.PresetGoal"
              :rows="3"
              maxlength="200"
              show-word-limit
              :disabled="submitShow"
            ></el-input>
          </el-form-item>
          <el-form-item class="el-form-item-three">
            <label class="require-icon">3.您给自己打多少分？（满分100）</label>
            <el-input-number
              v-model.trim="Project.SelfRatedScore"
              :min="0"
              :max="100"
              :controls="false"
              :disabled="submitShow"
            ></el-input-number>
          </el-form-item>
          <!-- 老师评分方面 -->
          <el-form-item
            label="老师评价情况"
            class="strong-label"
            v-if="teacherOrStudentState ? true : scoreShow"
          >
            <label class="require-icon">评分：</label>
            <el-input-number
              placeholder="分数"
              v-model.trim="Project.Score"
              :min="0"
              :max="100"
              :disabled="!teacherOrStudentState"
              :controls="false"
            ></el-input-number>
          </el-form-item>
          <el-form-item v-if="teacherOrStudentState ? true : scoreShow">
            <label class="require-icon">评语：</label>
            <el-input
              class="score-text"
              placeholder="给学生的评语，学生可在实训报告页面查看"
              v-model.trim="Project.Appraise"
              type="textarea"
              :disabled="!teacherOrStudentState"
              :rows="3"
              maxlength="200"
              show-word-limit
            />
          </el-form-item>
        </el-form>
      </template>
    </gat-popup>

    <!-- 设置考核 -->
    <gat-popup
      :class="['popup-score-assessment', popupActive === 'assessmentScore' ? 'on' : 'off']"
      :title="`评分（ ${assessmentItems} 项考核，共100分）`"
      :primary-button="'确定'"
      @cancel="cancelPopup"
      @confirm="UpdateScore($event)"
    >
      <template v-slot:content>
        <div class="popup-content-add">
          <!-- <div class="fraction">
            <span class="total-score">总分数：<span class="span-blue">100</span></span>
            <span class="span-red">*请勾选并设置需要的考核内容及分值比例。</span>
          </div> -->

          <div class="assessment-content">
            <div class="content-settings">
              <div class="content-settings-title">
                <span>考核内容</span>
                <span>自动判分</span>
                <span>本项分值</span>
                <span>实际得分</span>
              </div>
              <ul class="ul">
                <!-- 展示系统检验结果 -->
                <li v-for="(item, index) in appraisalSettingsData" :key="index">
                    <div class="li" v-if="item.type == 1 && item.totalScore != 0">
                      <div class="div checked-settings">
                        <span class="span-index">{{index+1}}</span>
                        <div>实训流程考核：完成实训项目则得分。</div>
                      </div>
                      <div class="div switch-div">
                        <el-switch
                          v-model="item.automaticScoringState"
                          active-color="#4c88ff"
                          inactive-color="#DCDFE6"
                          disabled
                        ></el-switch>
                      </div>
                      <div class="div input-Score">
                        <el-input type="text" v-model="item.totalScore" disabled></el-input>
                        <!-- <span>&nbsp;%</span> -->
                      </div>
                      <div class="div input-Score">
                        <el-input type="text" v-model="item.trueScore" @blur="inputScoreProportion(item, index)" :disabled="!teacherOrStudentState"></el-input>
                        <!-- <span>&nbsp;%</span> -->
                      </div>
                    </div>
                    <div class="li li-model-evaluation" v-if="item.type == 2 && item.totalScore != 0">
                      <div class="div">
                        <span class="span-index">{{index+1}}</span>
                        <div class="model-evaluation-table">
                          <p>指标考核：当<span class="span-red">数据集名称</span>与项目题解一致时，则得分。</p>
                          <table class="assessment-name"> 
                            <tr>
                              <th>项目题解<i class="td-line"></i></th>
                              <th>学生题解<i class="td-line"></i></th>
                              <th>比对结果</th>
                            </tr>
                            <tr v-for="(itm, idx) in item.contrastValue" :key="idx"> 
                              <td><span class="span-width" :title="itm.teaValue">{{itm.teaValue?itm.teaValue:'-'}}</span></td>
                              <td><span class="span-width" :title="itm.stuValue">{{itm.stuValue?itm.stuValue:'-'}}</span></td>
                              <td><i :class="['icon-wrong', {'icon-correct': itm.result == 1}]"></i></td>
                            </tr> 
                          </table> 
                        </div>
                      </div>
                      <div class="div">
                        <el-switch
                          v-model="item.automaticScoringState"
                          active-color="#4c88ff"
                          inactive-color="#DCDFE6"
                          disabled
                        ></el-switch>
                      </div>
                      <div class="div">
                        <el-input type="text" v-model="item.totalScore" disabled></el-input>
                      </div>
                      <div class="div">
                        <el-input type="text" v-model="item.trueScore" @blur="inputScoreProportion(item, index)" :disabled="!teacherOrStudentState"></el-input>
                      </div>
                    </div>
                    <div class="li li-model-evaluation" v-if="item.type == 3 && item.totalScore != 0">
                      <div class="div">
                        <span class="span-index">{{index+1}}</span>
                        <div class="model-evaluation-table">
                          <p>指标考核：当<span class="span-red">标签名称</span>与项目题解一致时，则得分。</p>
                          <table class="assessment-name"> 
                            <tr>
                              <th>项目题解<i class="td-line"></i></th>
                              <th>学生题解<i class="td-line"></i></th>
                              <th>比对结果</th>
                            </tr>
                            <tr v-for="(itm, idx) in item.contrastValue" :key="idx"> 
                              <td><span class="span-width" :title="itm.teaValue">{{itm.teaValue?itm.teaValue:'-'}}</span></td>
                              <td><span class="span-width" :title="itm.stuValue">{{itm.stuValue?itm.stuValue:'-'}}</span></td>
                              <td><i :class="['icon-wrong', {'icon-correct': itm.result == 1}]"></i></td>
                            </tr> 
                          </table> 
                        </div>
                      </div>
                      <div class="div">
                        <el-switch
                          v-model="item.automaticScoringState"
                          active-color="#4c88ff"
                          inactive-color="#DCDFE6"
                          disabled
                        ></el-switch>
                      </div>
                      <div class="div">
                        <el-input type="text" v-model="item.totalScore" disabled></el-input>
                      </div>
                      <div class="div">
                        <el-input type="text" v-model="item.trueScore" @blur="inputScoreProportion(item, index)" :disabled="!teacherOrStudentState"></el-input>
                      </div>
                    </div>
                    <div class="li li-model-evaluation" v-if="item.type == 4 && item.totalScore != 0">
                      <div class="div">
                        <span class="span-index">{{index+1}}</span>
                        <div class="model-evaluation-table">
                          <p>指标考核：当<span class="span-red">模型名称</span>与项目题解一致时，则得分。</p>
                          <table class="assessment-name"> 
                            <tr>
                              <th>项目题解<i class="td-line"></i></th>
                              <th>学生题解<i class="td-line"></i></th>
                              <th>比对结果</th>
                            </tr>
                            <tr v-for="(itm, idx) in item.contrastValue" :key="idx"> 
                              <td><span class="span-width" :title="itm.teaValue">{{itm.teaValue?itm.teaValue:'-'}}</span></td>
                              <td><span class="span-width" :title="itm.stuValue">{{itm.stuValue?itm.stuValue:'-'}}</span></td>
                              <td><i :class="['icon-wrong', {'icon-correct': itm.result == 1}]"></i></td>
                            </tr> 
                          </table> 
                        </div>
                      </div>
                      <div class="div">
                        <el-switch
                          v-model="item.automaticScoringState"
                          active-color="#4c88ff"
                          inactive-color="#DCDFE6"
                          disabled
                        ></el-switch>
                      </div>
                      <div class="div">
                        <el-input type="text" v-model="item.totalScore" disabled></el-input>
                      </div>
                      <div class="div">
                        <el-input type="text" v-model="item.trueScore" @blur="inputScoreProportion(item, index)" :disabled="!teacherOrStudentState"></el-input>
                      </div>
                    </div>
                    <!-- 模型评估指标值 -->
                    <div class="li li-model-evaluation" v-if="item.type == 5 && item.totalScore != 0">
                      <div class="div checked-settings">
                        <span class="span-index">{{index+1}}</span>
                        
                        <div class="model-evaluation-table">
                          <p>指标考核：当<span class="span-red">模型评估指标值（N）</span>为指定数值时，则得分。</p>
                          <table class="assessment-name-table"> 
                            <tr>
                              <th>项目题解<i class="td-line"></i></th>
                              <th>学生题解</th>
                            </tr>
                            <tr> 
                              <td>{{item.teaSolution?item.teaSolution:'-'}}</td>
                              <td>{{item.stuSolution?item.stuSolution:'-'}}</td>
                              <!-- <td><el-input type="text" v-model="item.teaSolution" disabled></el-input></td>
                              <td><el-input type="text" v-model="item.stuSolution" disabled></el-input></td> -->
                            </tr> 
                          </table>
                          <table class="evaluation-table"> 
                            <tr>
                              <th>得分关键值区间<i class="td-line"></i></th>
                              <th>分值比例<i class="td-line"></i></th>
                              <th>比对结果</th>
                            </tr>
                            <tr v-for="(itm, idx) in item.contrastValue" :key="idx"> 
                              <td class="intervalvalueList-td">
                                <span class="icon-index">{{idx+1}}</span>
                                <div class="intervalvalueList-td-itm">
                                  <span>{{itm.min}}</span>
                                  <span v-text="'<'"></span>
                                  <span>N</span>
                                  <span>≤</span>
                                  <span>{{itm.max}}</span>
                                </div>
                              </td> 
                              <td class="input-td">
                                <el-input
                                  type="text"
                                  :id="'text'+idx"
                                  v-model="itm.scoreProportion"
                                  disabled
                                ></el-input>
                                <span>&nbsp;%</span>
                              </td>
                              <td><i :class="['icon-wrong', {'icon-correct': itm.result == 1}]"></i></td>
                            </tr> 
                          </table> 
                        </div>
                      </div>
                      <div class="div switch-div">
                        <el-switch
                          v-model="item.automaticScoringState"
                          active-color="#4c88ff"
                          inactive-color="#DCDFE6"
                          disabled
                        ></el-switch>
                      </div>
                      <div class="div input-Score">
                        <el-input type="text" v-model="item.totalScore" disabled></el-input>
                      </div>
                      <div class="div input-Score">
                        <el-input type="text" v-model="item.trueScore" @blur="inputScoreProportion(item, index)" :disabled="!teacherOrStudentState"></el-input>
                      </div>
                    </div>
                    <!-- 目标校验对象的校验结果 --> 
                    <div class="li li-model-evaluation" v-if="item.type == 6 && item.totalScore != 0">
                      <div class="div checked-settings">
                        <span class="span-index">{{index+1}}</span>
                        <div class="model-evaluation-table">
                          <p>指标考核：当<span class="span-red">目标校验对象的校验结果（X）</span>为指定数值时，则得分。</p>
                          <table class="target-verification-table"> 
                            <tr>
                              <th><i class="td-line"></i></th>
                              <th>项目题解<i class="td-line"></i></th>
                              <th>学生题解<i class="td-line"></i></th>
                              <th>置信度偏差区间<i class="td-line"></i></th>
                              <th>分值比例<i class="td-line"></i></th>
                              <th>比对结果</th>
                            </tr>
                            <tr>
                              <td>校验对象</td>
                              <td>
                                <span class="span">预测分类</span>  
                                <span class="span">置信度</span> 
                              </td>
                              <td>
                                <span class="span">预测分类</span>  
                                <span class="span">置信度</span> 
                              </td>
                              <td>/</td>
                              <td>/</td>
                              <td>/</td>
                            </tr> 
                            <tr v-for="(itm, idx) in item.contrastValue" :key="idx">
                              <td>
                                <span class="img-span">
                                  <img v-if="modelType == 1 || modelType == 2" :src="photoBaseUrl   + itm.fileUrl" @click="onFilePreview(itm.fileUrl)" title="预览" alt="" />
                                  <img v-if="modelType == 3 || modelType == 4" src="@/assets/images/txtImage@2x.png" @click="onFilePreview(itm.fileUrl)"   title="预览" alt="" />
                                  <img v-if="modelType == 5 || modelType == 6" src="@/assets/images/audioImage@2x.png" @click="onFilePreview(itm.fileUrl)"   title="预览" alt="" />
                                </span>
                              </td>
                              <td>
                                <span class="span table-td-list">
                                  <span class="table-td-item" v-for="(val, l) in itm.teacher" :key="l" :title="val.labelName">{{val.labelName || "-"}}</span>
                                </span>
                                <span class="span table-td-list">
                                  <span class="table-td-item" v-for="(val, l) in itm.teacher" :key="l">{{val.confidence || "-"}}</span>
                                </span>
                              </td>
                              <td>
                                <span class="span table-td-list">
                                  <span class="table-td-item" v-for="(val, l) in itm.student" :key="l" :title="val.labelName">{{val.labelName || "-"}}</span>
                                </span>
                                <span class="span table-td-list">
                                  <span class="table-td-item" v-for="(val, l) in itm.student" :key="l">{{val.confidence || "-"}}</span>
                                </span>
                              </td> 
                              <td>
                                <el-input
                                  type="text"
                                  :id="'interval'+idx"
                                  v-model="itm.section"
                                  disabled
                                ></el-input>&nbsp;~&nbsp;1
                              </td>
                              <td class="input-td">
                                <el-input
                                  type="text"
                                  :id="'text'+idx"
                                  v-model="itm.scoreProportion"
                                  disabled
                                ></el-input>
                                <span>&nbsp;%</span>
                              </td>
                              <td><i :class="['icon-wrong', {'icon-correct': itm.result == 1}]"></i></td>
                            </tr> 
                          </table> 
                        </div>
                      </div>
                      <div class="div switch-div">
                        <el-switch
                          v-model="item.automaticScoringState"
                          active-color="#4c88ff"
                          inactive-color="#DCDFE6"
                          disabled
                        ></el-switch>
                      </div>
                      <div class="div input-Score">
                        <el-input type="text" v-model="item.totalScore" disabled></el-input>
                      </div>
                      <div class="div input-Score">
                        <el-input type="text" v-model="item.trueScore" @blur="inputScoreProportion(item, index)" :disabled="!teacherOrStudentState"></el-input>
                      </div>
                    </div>
                    <!-- 自定义考核内容 -->
                    <div class="li li-model-evaluation li-border-none" v-if="item.type == 7 && item.totalScore != 0">
                      <div class="div checked-settings">
                        <span class="span-index">{{index+1}}</span>
                        
                        <div class="model-evaluation-table">
                          <p>自定义考核：当<span class="span-red">自定义考核内容</span>符合实训任务要求时，则得分。</p>
                          <p class="span-red p-text-min" v-if="teacherOrStudentState">* 本项为老师主观定义的考核，可根据具体实训要求设置，系统不作自动判分。</p>
                          <div class="custom-content">
                            <span>自定义内容：</span>
                            <el-input
                              class="score-text"
                              placeholder="请输入自定义考核内容"
                              v-model.trim="item.checkValue"
                              type="textarea"
                              :rows="3"
                              maxlength="200"
                              show-word-limit
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                      <div class="div switch-div"></div>
                      <div class="div input-Score">
                        <el-input type="text" v-model="item.totalScore" disabled></el-input>
                      </div>
                      <div class="div input-Score">
                        <el-input type="text" v-model="item.trueScore" @blur="inputScoreProportion(item, index)" :disabled="!teacherOrStudentState"></el-input>
                      </div>
                    </div>
                </li>

                <!-- 学生自评、老师评分 -->
                <div class="li-form">
                  <el-form ref="submitProject" :model="Project" label-width="110px">
                    <el-form-item label="学生自评情况：" class="strong-label">
                      <label class="require-icon">
                        1.是否已掌握项目实训点及技能点？
                      </label>
                      <el-input
                        type="textarea"
                        v-model.trim="Project.Points"
                        :rows="3"
                        maxlength="200"
                        show-word-limit
                        :disabled="submitShow"
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <label class="require-icon">2.实训项目的预设目标有没有实现？效果如何？</label>
                      <el-input
                        type="textarea"
                        v-model.trim="Project.PresetGoal"
                        :rows="3"
                        maxlength="200"
                        show-word-limit
                        :disabled="submitShow"
                      ></el-input>
                    </el-form-item>
                    <el-form-item class="el-form-item-three">
                      <label class="require-icon">3.您给自己打多少分？（满分100）</label>
                      <el-input-number
                        v-model.trim="Project.SelfRatedScore"
                        :min="0"
                        :max="100"
                        :controls="false"
                        :disabled="submitShow"
                      ></el-input-number>
                    </el-form-item>

                    <el-form-item
                      label="系统判分情况："
                      class="strong-label"
                      v-if="teacherOrStudentState"
                    >
                      <div><span class="span-blue">{{systemScore}}</span>分</div>
                    </el-form-item>
                    <el-form-item
                      label="老师评价情况："
                      class="strong-label"
                      v-if="teacherOrStudentState ? true : scoreShow"
                    >
                      <div>
                        评分<span class="span-blue span-score">{{Project.Score}}</span>共100.00分
                        <span class="span-red" v-if="teacherOrStudentState">
                          （* 修改具体考核项实际分值，可自动统计最终评分成绩）
                        </span>
                      </div>
                    </el-form-item>
                    <el-form-item
                      label="评语："
                      class="strong-label comment-label"
                      v-if="teacherOrStudentState ? true : scoreShow"
                    >
                      <!-- <label class="require-icon">评语：</label> -->
                      <el-input
                        class="score-text"
                        placeholder="给学生的评语，学生可在实训报告页面查看"
                        v-model.trim="Project.Appraise"
                        type="textarea"
                        :disabled="!teacherOrStudentState"
                        :rows="3"
                        maxlength="200"
                        show-word-limit
                      />
                    </el-form-item>
                  </el-form>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </template>
    </gat-popup>

    <!--文件预览-->
    <file-preview
      :modelType="modelType"
      :fileUrl="fileUrl"
      :dialogvisibleview="dialogvisibleview"
      @onClickDialog="dialogvisibleview = false"
    ></file-preview>
  </div>
</template>

<script>
import MARKCENTER from '@/axios/trainingCenter/MarkCenter/MarkCenter.js'; // 项目标注接口

import GatPopup from '@/components/common/GatPopup';
import FilePreview from '@/components/pretrain/FilePreview.vue'

export default {
  name: 'PopupScore',
  components: { GatPopup, FilePreview },
  props: {
    popupActive: {
      type: String,
      default: ''
    },
    teacherOrStudentState: {
      type: Boolean,
      default: false
    },
    submitShow: {
      type: Boolean,
      default: false
    },
    scoreShow: {
      type: Boolean,
      default: false
    },
    ProjectData: {
      type: Object,
      default: {}
    },
    modelType: {
      type: String,
      default: '1'
    },
    trainingId: {
      type: String,
      default: ''
    },
    teacherId: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 新UC文件基地址
      fileUrl: '',
      dialogvisibleview: false,
      Project: {
        Points: '', // 技能点
        PresetGoal: '', // 预设目标
        SelfRatedScore: '', // 学生自评分数
        Score: '', // 老师评分
        Appraise: '', // 老师评语
      },
      assessmentItems: 0, // 考核项数
      systemScore: 0, // 系统评分
      appraisalSettingsData: [],
      scoreTitle: '实训评分',
    }
  },
  watch: {
    ProjectData: {
      handler(val) {
        this.Project = JSON.parse(JSON.stringify(val));
      },
      deep: true,
      immediate: true,
    },
    popupActive: {
      handler(val) {
        if (val == 'assessmentScore') {
          // 老师、学生查看评分实训考核结果 
          this.getTrainingAssessReport()
        }
        if (this.teacherOrStudentState) {
          this.scoreTitle = this.scoreShow ? '实训报告' : '实训评分';
        } else {
          this.scoreTitle = this.submitShow ? '实训报告' : '实训评分';
        }
      },
      deep: true,
      immediate: true,
    },
    appraisalSettingsData: {
      handler(val) {
        this.assessmentItems = 0;
        let scoreAll = 0;
        val.forEach(item => {
          if (item.scoreOfThisItem != 0) {
            this.assessmentItems++;
          }
          if (item.scoreOfThisItem != 0) {
            scoreAll += Number(item.trueScore) * 100;
          }
        });
        // 得分项总和
        scoreAll = (scoreAll / 100).toString().replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3'); // 只保留2个小数
        this.Project.Score = Number(scoreAll);
        if (this.Project.Score > 100 ) {
          this.$message.error(`实际得分总和不能超过100分，请修改！`);
        }
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    // 预览文件
    onFilePreview(imgUrl) {
      this.fileUrl = this.photoBaseUrl + imgUrl;
      this.dialogvisibleview = true;
    },
    // 老师、学生查看评分实训考核结果 
    getTrainingAssessReport() {
      let studentId = '';
      if (this.teacherOrStudentState) {
        studentId = this.$route.query.studentId || ''; // 老师查实训考核-获取学生id
      } else {
        studentId = this.$store.state.accountInfo.userId; // 学生查实训考核-取当前学生登录id
      }

      let data = {
        trainingId: this.trainingId, 
        editorType: this.modelType,
        teacherId: this.teacherId, // 老师id
        studentId: studentId, // 学生id
      }
      MARKCENTER.getTrainingAssessReport(data).then(result => {
        if (result.isSuccess) {
          this.systemScore = result.data.systemScore;
          this.appraisalSettingsData = result.data.assessData;
          this.appraisalSettingsData.forEach(item => {
            item.automaticScoringState = item.automaticScoringState == 1 ? true : false;
          });
        } else {
          this.$message.error(result.returnMsg);
        }
      });
    },
    // 分值数据处理
    clearNoNum (value) {
      value = value.toString();
      value = value.replace(/[^\d.]/g,""); //清除"数字"和"."以外的字符
      value = value.replace(/^\./g,""); //验证第一个字符是数字
      value = value.replace(/\.{2,}/g,"."); //只保留第一个, 清除多余的
      value = value.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
      value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3'); //只能输入两个小数
      if(value.indexOf(".") < 0 && value !=""){//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额 
        if(value.substr(0,1) == '0' && value.length == 2){ 
          value = parseFloat(value);     
        } 
      }
      return value
    },
    // 分值比例判断是否超过100%
    inputScoreProportion(obj, index) {
      let value = this.clearNoNum(obj.trueScore); // 分值数据处理
      // value = value !== '' ? `${parseInt(value)}`: '0';
      value = value !== '' ? value: '0';
      this.appraisalSettingsData[index].trueScore = value;

      if (Number(value) > obj.totalScore) {
        this.appraisalSettingsData[index].trueScore = obj.totalScore
        // this.$message.error(`实际得分超过本项分值，请重新输入!`);
      }
    },
    UpdateScore() {
      if (this.teacherOrStudentState) {
        if (this.popupActive == 'assessmentScore') {
          this.appraisalSettingsData.forEach(item => {
            if (item.type == 1) {
              this.Project.processTrueScore = item.trueScore; // 流程考核得分
            } else if (item.type == 2) {
              this.Project.datasetTrueScore = item.trueScore; // 数据集考核得分
            } else if (item.type == 3) {
              this.Project.labelTrueScore = item.trueScore; // 标签考核得分
            } else if (item.type == 4) {
              this.Project.modelTrueScore = item.trueScore; // 模型考核得分
            } else if (item.type == 5) {
              this.Project.indexTrueScore = item.trueScore; // 模型评估指标考核得分
            } else if (item.type == 6) {
              this.Project.checkTrueScore = item.trueScore; // 目标校验对象的校验结果考核得分
            } else if (item.type == 7) {
              this.Project.customTrueScore = item.trueScore; // 自定义考核得分
            }
          });
        }
        this.$emit('UpdateScore', this.Project); // 老师评分
      } else { // 学生
        if (this.popupActive == 'assessmentScore') { // 已设置考核
          this.$emit('cancelPopup');
        } else { // 未设置考核
          if (!this.submitShow) { // 学生未自评
            this.$emit('UpdateScore', this.Project); // 学生自评
          } else { // 学生已自评
            this.$emit('cancelPopup');
          }
        }
      }
    },
    cancelPopup() {
      this.$emit('cancelPopup');
    },
  },
}
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
}

.popup-list {
  .span-red {
    color: red;
  }
  .span-blue {
    color: #4C88FF ;
  }
  .popup-score {
    &.off {
      display: none;
    }
    &::v-deep .popup-inner {
      width: 620px;
      height: 620px;
      max-height: 90%;
      .popup-head {
        .title {
          color: #4C88FF;
        }
      }
      .popup-content {
        // margin-top: 20px;
        .el-form {
          width: 90%;
          .el-form-item {
            margin-bottom: 5px;
            &.strong-label {
              margin-top: 10px;
              .el-form-item__label {
                font-weight: 600;
              }
            }
          }
        }
        .el-form-item-three {
          margin-top: 20px;
        }
      }
    }
  }

  .popup-score-assessment {
    &.off {
      display: none;
    }
    &::v-deep .popup-inner {
      width: 1000px;
      height: 700px;
      .popup-head {
        .title {
          color: #4C88FF;
        }
      }
      .popup-content {
        .el-form {
          width: 90%;
          .el-form-item {
            margin-bottom: 5px;
            &.strong-label {
              .el-form-item__label {
                font-weight: 600;
              }
            }
            &.comment-label {
              .el-form-item__label {
                line-height: 20px;
              }
            }
          }
        }
      }
      .el-input {
        width: 50px;
        height: 20px;
        margin-top: 0;
        text-align: center;
      }
      .el-input__inner {
        width: 50px;
        height: 20px;
        padding: 0 2px;
        text-align: center;
      }
    }

    .popup-content-add {
      color: #333333;
      height: 520px;
      padding: 0;
      .fraction {
        height: 42px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          &.total-score {
            font-size: 16px;
            margin-left: 20px;
          }
          &.span-red {
            font-size: 12px;
          }
        }
      }

      .assessment-content {
        height: 100%;
        display: flex;
        margin-top: 20px;
        .content-settings {
          height: 100%;
          flex: 1;
          // border: 1px solid #D8E5FD;
          // border-radius: 5px;
          overflow: hidden;
          .content-settings-title {
            color: #fff;
            width: 100%;
            height: 30px;
            background: #4C88FF;
            border-radius: 5px 5px 0 0;
            line-height: 30px;
            padding: 0 20px;
            span {
              display: inline-block;
              text-align: center;
              &:first-child {
                width: 70%;
                text-align: left;
              }  
              &:nth-child(n+2) {
                width: 10%;
              }
            }
          }

          .ul {
            height: calc(100% - 30px);
            border: 1px solid #D8E5FD;
            border-radius: 0 0 5px 5px;
            // padding-bottom: 30px;
            // overflow-y: scroll;
            overflow: auto;
            position: relative;
            &::-webkit-scrollbar {
              width: 8px; /*滚动条宽度*/
              height: 8px; /*滚动    条高度*/
            }
      
            /*定义滚动条轨道 内阴影+圆角*/
            &::-webkit-scrollbar-track {
              // box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
              // -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
              // border-radius: 10px; /*滚动条的背景区域的圆角*/
              // background: rgba(0, 96, 255, 0.1); /*滚动条的背景颜色*/
            }
      
            /*定义滑块 内阴影+圆角*/
            &::-webkit-scrollbar-thumb {
              border-radius: 10px; /*滚动条的圆角*/
              box-shadow: inset 0 0 6px #919BB3;
              -webkit-box-shadow: inset 0 0 6px #919BB3;
              background: #919BB3; /*滚动条的背景颜色*/
              position: absolute;
              top: 0;
              right: -10px;
            }

            .el-input {
              width: 50px;
              // height: 20px;
              margin-top: 0;
              // text-align: center;
            }
            /deep/ .el-input__inner {
              width: 50px;
              height: 20px;
              line-height: 20px;
              padding: 0 2px;
              text-align: center;
            }

            .li {
              min-height: 48px;
              font-size: 14px;
              border-bottom: 1px solid #D8E5FD;
              padding: 0 0 0 20px;
              display: flex;
              justify-content: center;
              align-items: center;
              
              // &.li-border-none {
              //   border-bottom: none;
              // }
              .div {
                line-height: 48px;
                &:first-child {
                  width: 70%;
                  display: flex;
                  .span-index {
                    margin-right: 20px;
                  }
                }
                &:nth-child(n+2) {
                  width: 10%;
                  text-align: center;
                }
              }

              &.li-model-evaluation {
                height: 100%;
                display: flex;
                align-items: stretch;
  
                .model-evaluation-table {
                  width: 100%;
                  p {
                    height: 48px;
                    line-height: 48px;
                    padding-bottom: 5px;
                  }
                  .assessment-name,
                  .assessment-name-table,
                  .evaluation-table,
                  .target-verification-table {
                    width: 100%;
                    // width: 500px;
                    border-radius: 4px;
                    overflow: hidden;
                    margin-bottom: 20px;
                    tr {
                      border: 1px solid #D8E5FD;
                      line-height: 40px;
                      th,
                      td {
                        min-height: 40px;
                        background: #D8E5FD;
                        text-align: center;
                        border-right: 1px solid #D8E5FD;
                        &:nth-child(n+2) {
                          // width: 33.33%;
                        }
                        &:last-child {
                          // width: 20%;
                          border-bottom: 1px solid #D8E5FD;
                        }
                      }
                      th {
                        color: #4C88FF;
                        line-height: 40px;
                        .td-line {
                          width: 1px;
                          height: 20px;
                          background: #FFFFFF;
                          float: right;
                          margin-top: 10px;
                          margin-right: -1px;
                        }
                      }
                      td {
                        background-color: #F0F2FF;
                        position: relative;
                        .icon-wrong {
                          width: 24px;
                          height: 24px;
                          background: url('../../../../assets/images/trainingCenter/icon-wrong.png') no-repeat;
                          background-size: 100% 100%;
                          position: absolute;
                          top: 0;
                          left: 0;
                          right: 0;
                          bottom: 0;
                          margin: auto;
                        }
                        .icon-correct {
                          background: url('../../../../assets/images/trainingCenter/icon-correct.png') no-repeat;
                          background-size: 100% 100%;
                        }
                      }
  
                      .input-td {
                        input {
                          color: #666;
                          width: 40px;
                          height: 20px;
                          border: 1px solid #ccc;
                          border-radius: 4px;
                          font-size: 14px;
                          padding: 0 5px;
                          box-sizing: border-box;
                          &:focus {
                            border: 1px solid #4c88ff;
                          }
                        }
                      }
                    }
                  }
                  .assessment-name {
                    tr {
                      // display: flex;
                      // justify-content: center;
                      // align-items: center;
                      th,
                      td {
                        width: 33.33%;
                        line-height: 40px;
                        .span-width {
                          display: inline-block;
                          width: 180px;
                          height: 14px;
                          line-height: 14px;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                          cursor: default;
                          margin: auto 0;
                        }
                      }
                    }
                  }
                  .assessment-name-table {
                    tr {
                      th,
                      td {
                        width: 50%;
                      }
                    }
                  }
                  // 模型评估指标值
                  .evaluation-table {
                    tr {
                      th,
                      td {
                        &:nth-child(n+2) {
                          width: 25%;
                        }
                      }
                    }
                    .intervalvalueList-td {
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      .icon-index {
                        color: #fff;
                        width: 20px;
                        height: 20px;
                        line-height: 20px;
                        background-color: #4C88FF;
                        border-radius: 50%;
                        font-size: 16px;
                        margin: 0 5% 0 15%;
                      }
                      .intervalvalueList-td-itm {
                        width: 70%;
                        height: 100%;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 0 15% 0 0;
                        span {
                          flex: 1;
                        }
                      }
                    }
                  }
                  // 目标校验对象
                  .target-verification-table {
                    width: 130%;
                    tr {
                      td {
                        &:first-child {
                          .img-span {
                            display: flex;
                            justify-content: center;
                            align-content: center;
                            img {
                              width: 30px;
                              height: 30px;
                              cursor: pointer;
                            }
                          }
                        }
                        &:nth-child(2),
                        &:nth-child(3) {
                          width: 25%;
                          .span {
                            width: 50%;
                            height: 100%;
                            min-height: 40px;
                            display: inline-block;
                            box-sizing: border-box;
                            &:nth-child(2) {
                              border-left: 1px solid #D8E5FD;
                              // border-right: 1px solid #D8E5FD;
                            }
                            &:nth-child(3) {
                              border-right: 1px solid #D8E5FD;
                            }
                          }
                          .table-td-list {
                            display: flex;
                            float: left;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            .table-td-item {
                              width: 80px;
                              height: 25px;
                              border-bottom: 1px solid #D8E5FD;
                              line-height: 25px;
                              box-sizing: border-box;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              white-space: nowrap;
                              cursor: default;
                              &:last-child {
                                border-bottom: none;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
  
                  .custom-content {
                    display: flex;
                    margin-bottom: 20px;
                    span {
                      width: 120px;
                      line-height: 20px;
                    }
                  }
                  .p-text-min {
                    height: 12px;
                    font-size: 12px;
                    line-height: 12px;
                    margin-bottom: 17px;
                  }
                }
              }
            }

            .li-form {
              background-color: rgba(7, 181, 250, 0.05);
              padding: 0 0 30px 20px;
              .span-score {
                background-color: rgba(255, 0, 0, 0.2);
                padding: 3px 5px;
                margin: 0 5px;
              }
            }
          }
        }
      }
    }
  }
}
</style>